<script lang="ts">
  import { EmbedType } from 'src/config';
  import { setBusinessKey } from 'src/stores/floating-widget-settings-store';
  import FloatingWidget from './widgets/floating/FloatingWidget.svelte';
  import Marquee from './widgets/marquee/marquee.svelte';
  import Wall from './widgets/wall/wall.svelte';

  export let embedType: string = '';
  export let businessKey: string;

  setBusinessKey(businessKey);
</script>

{#if embedType === EmbedType.WallOfLove}
  <Wall {businessKey} />
{:else if embedType === EmbedType.Marquee}
  <Marquee {businessKey} />
{:else}
  <FloatingWidget {businessKey} />
{/if}

<style lang="scss">
  @import './stylesheets/variables.scss';
  @import './stylesheets/size.scss';

  $base-text-size: 16px;
  $base-line-height: 1.25;

  :host {
    --base: #424242;
    --light-1: #757575;
    --light-2: #bdbdbd;
    --light-3: #eeeeee;

    --primary: #41c0ae;
    --ravely-primary: #41c0ae;
    --primary-light-1: lighten(var(--primary), 20%);

    --positive: hsl(153, 53%, 53%);
    --negative: hsl(348, 86%, 61%);
    --rating: hsl(44, 100%, 77%);

    --text-weight-normal: 400;

    --theme-text-color: white;

    display: contents;
    color: var(--base);
    font-size: $base-text-size;
    line-height: $base-line-height;
    letter-spacing: 0;
    font-weight: var(--text-weight-normal);
  }

  :global {
    * {
      box-sizing: border-box;
      /**
      * Roboto seems to be perma bold on Property Lim Brothers
      */
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI',
        /*Roboto,*/ Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
    }

    a {
      text-decoration: none;
    }

    a:visited {
      color: rgb(0, 80, 160);
    }

    label {
      display: block;
    }

    input,
    button,
    select,
    textarea {
      font-family: inherit;
      font-size: inherit;
      -webkit-padding: 0.4em 0;
      padding: 0.4em;
      box-sizing: border-box;
      border: 1px solid #ccc;
      border-radius: 2px;
    }

    input:disabled {
      color: #ccc;
    }

    button {
      color: #333;
      background-color: #f4f4f4;
      outline: none;
    }

    button:disabled {
      color: #999;
    }

    button:not(:disabled):active {
      background-color: #ddd;
    }

    button:focus {
      border-color: #666;
    }

    /* Text color */
    .text-base {
      color: var(--base);
    }

    .text-light-1 {
      color: var(--light-1);
    }
    .text-light-2 {
      color: var(--light-2);
    }
    .text-light-3 {
      color: var(--light-3);
    }
    .text-rating {
      color: var(--rating);
    }
    .text-negative {
      color: var(--negative);
    }

    /* Text style */
    .text-caption {
      font-size: round(0.85 * $base-text-size);
      font-weight: 400;
      letter-spacing: 0.03333em;
      line-height: 1.25 * $base-line-height;
    }

    .text-overline {
      font-size: round(0.85 * $base-text-size);
      font-weight: 500;
      letter-spacing: 0.16667em;
      line-height: 2 * $base-line-height;
    }

    .text-centered {
      text-align: center;
    }

    .text-ellipsis {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    /* Styling */
    .rounded-borders {
      border-radius: 16px;
    }

    .border-1 {
      border: 1px solid #ccc;
    }

    .shadow-2 {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
    }

    .content {
      max-width: 100%;
      white-space: pre-line;
      overflow-wrap: break-word;
    }
  }
</style>
